import React, { useCallback, useEffect, useState } from 'react'
import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { useHistoricoService } from 'hooks/useHistoricoService'
import useStyles from './styles'

export const HistoricoOperacoes = (props) => {
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const { id, tipo, refresh } = props
  const historicoService = useHistoricoService()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const [historico, setHistorico] = useState([])
  const [processandoHistorico, setProcessandoHistorico] = useState(false)

  const fetchHistorico = useCallback(async () => {
    const response = await historicoService.listarHistoricoAsync(id, tipo, setProcessandoHistorico)
    setHistorico(response)
  }, [id, tipo])

  useEffect(() => {
    fetchHistorico()
  }, [refresh, fetchHistorico])

  return (
    <Grid container>
      {processandoHistorico ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid item xs={12}>
          {isMobile ? (
            <div className={classes.mobileContainer}>
              {historico?.length ? (
                historico.map((item) => (
                  <div key={item.id} className={classes.mobileCard}>
                    <div className={classes.mobileHeader}>
                      <Typography className={classes.mobileActionTitle}>
                        {item.operacao?.toUpperCase() || ''}
                      </Typography>
                    </div>
                    <div className={classes.mobileDetailRow}>
                      <Typography className={classes.mobileDetailItem} variant="body2">
                        Usuário: <span>{item.usu?.nome?.toUpperCase() || '-'}</span>
                      </Typography>
                      <Typography className={classes.mobileDetailItem} variant="body2">
                        Cargo: <span>{item.usu?.cargo?.nome?.toUpperCase() || '-'}</span>
                      </Typography>
                      <Typography className={classes.mobileDetailItem} variant="body2">
                        Data/Hora: <span>{moment(item.createdAt).format('DD/MM/YYYY HH:mm')}</span>
                      </Typography>
                    </div>
                  </div>
                ))
              ) : (
                <div className={classes.mobileCard} style={{ textAlign: 'center' }}>
                  <Typography className={classes.emptyState}>
                    Não há registro de operações para esta entidade
                  </Typography>
                </div>
              )}
            </div>
          ) : (
            <TableContainer className={classes.tableContainer}>
              <Table aria-label="collapsible table" size="small">
                <TableHead>
                  <TableRow className={classes.tableHeader}>
                    <TableCell className={classes.tableHeaderCell}>AÇÃO</TableCell>
                    <TableCell className={classes.tableHeaderCell}>USUÁRIO</TableCell>
                    <TableCell className={classes.tableHeaderCell}>CARGO</TableCell>
                    <TableCell className={classes.tableHeaderCell}>DATA E HORA DA OPERAÇÃO</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {historico?.length ? (
                    historico.map((item) => <LinhaTabelaHistorico key={item.id} item={item} />)
                  ) : (
                    <TableRow className={classes.tableRow}>
                      <TableCell colSpan={4} className={classes.emptyState}>
                        Não há registro de operações para esta entidade
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      )}
    </Grid>
  )
}

const LinhaTabelaHistorico = (props) => {
  const { item } = props
  const classes = useStyles()

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableCell}>
        {item.operacao?.toUpperCase() || ''}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {item.usu?.nome?.toUpperCase() || ''}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {item.usu?.cargo?.nome?.toUpperCase() || '-'}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {moment(item.createdAt).format('LLLL')}
      </TableCell>
    </TableRow>
  )
}
